<div class="max-w-screen-xl p-6 mx-auto border border-gray-200 shadow-lg bg-white/90 backdrop-blur-md rounded-xl">
  <!-- Titre de la page -->
  <h1 class="mb-6 text-3xl font-bold text-gray-800">Gestion des Partenaires</h1>

  <div class="flex flex-col gap-6 md:flex-row">
    <!-- Première colonne (2/3 de largeur) -->
    <div class="w-full space-y-6 md:w-2/3">
      <!-- Liste des inspections -->
      <div class="grid grid-cols-1 gap-4">
        <h2 class="text-xl font-semibold text-gray-800">Liste des
          Partenaires</h2>

        <!-- Cartes des partenaires -->
        <div *ngFor="let inspection of inspections"
          class="flex flex-col items-center overflow-hidden bg-white border border-gray-200 rounded-lg shadow-sm cursor-pointer hover:bg-gray-50 sm:flex-row"
          (click)="openDetailsModal(inspection)">
          <div class="w-full p-4 sm:w-2/3">
            <h3 class="font-medium text-gray-800">{{inspection.nom}}</h3>
            <p class="text-sm text-gray-600">Date de création: {{
              inspection.createdDate | date:'short' }}</p>
          </div>
          <div class="flex justify-end w-full p-4 sm:w-1/3">
            <span class="inline-flex items-center px-3 py-1 text-sm font-medium rounded-full"
              [ngClass]="inspection.status ? 'text-green-800 bg-green-100' : 'text-red-800 bg-red-100'">
              {{ inspection.status ? "Activé" : "Désactivé" }}
            </span>
          </div>
        </div>
      </div>

      <!-- Ligne de séparation de 50% -->
      <div class="flex justify-center my-6">
        <hr class="w-1/2 border-gray-300">
      </div>
      <div class="grid grid-cols-1 gap-4" *ngIf="rapportAmount.length>0">
        <h2 class="text-xl font-semibold text-gray-800">Montant des Rapports
          d'inspection</h2>

        <!-- Cartes des partenaires -->
        <div *ngFor="let montant of rapportAmount"
          class="flex flex-col items-center overflow-hidden bg-white border border-gray-200 rounded-lg shadow-sm cursor-pointer hover:bg-gray-50 sm:flex-row"
          (click)="openInspectionAmountDetailsModal(montant)">
          <div class="w-full p-4 sm:w-2/3">
            <h3 class="font-medium text-gray-800">{{montant.montant |
              number:'1.1-2'}} XAF</h3>
            <p class="text-sm text-gray-600">Date de création: {{
              montant.createdDate | date:'short' }}</p>
          </div>
          <div class="flex justify-end w-full p-4 sm:w-1/3">
            <span
              class="inline-flex items-center px-3 py-1 text-sm font-medium text-green-800 bg-green-100 rounded-full">
              Ajouté et appliqué
            </span>
          </div>
        </div>
      </div>

      <div class="items-center justify-center gap-4 p-4 border border-gray-200 rounded-lg shadow-sm">
        <span *ngIf="rapportAmount.length>0; else non">✅ Montant Ajouté
        </span>
        <ng-template #non>❌ Aucun montant des Rapports défini pour le
          moment</ng-template>
      </div>

      <!-- Première ligne - Deux graphiques -->
      <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
        <!-- Graphique 1 -->
        <div class="p-4 bg-white border border-gray-200 rounded-lg shadow">
          <h3 class="mb-3 font-medium text-gray-800">Statut des Partenaires</h3>
          <div class="flex justify-center">
            <apx-chart [series]="inspectionStatusChart.series" [chart]="inspectionStatusChart.chart"
              [labels]="inspectionStatusChart.labels" [colors]="inspectionStatusChart.colors"
              [legend]="inspectionStatusChart.legend" [dataLabels]="inspectionStatusChart.dataLabels"
              [tooltip]="inspectionStatusChart.tooltip" [responsive]="inspectionStatusChart.responsive">
            </apx-chart>
          </div>
          <div class="mt-4 space-y-2">
            <div class="flex items-center">
              <div class="w-3 h-3 mr-2 bg-green-500 rounded-full"></div>
              <span class="text-sm text-gray-600">Activé: {{ pieChartData[0] |
                number: '1.1-2'
                }}%</span>
            </div>
            <div class="flex items-center">
              <div class="w-3 h-3 mr-2 bg-red-500 rounded-full"></div>
              <span class="text-sm text-gray-600">Désactivé: {{ pieChartData[1]
                | number: '1.1-2'
                }}%</span>
            </div>
          </div>
        </div>

        <!-- Graphique 2 -->
        <div class="p-4 bg-white border border-gray-200 rounded-lg shadow">
          <h3 class="mb-3 font-medium text-gray-800">Nombre de cartes créées par
            Inspection</h3>
          <div class="flex justify-center">
            <apx-chart [series]="usersByPartyChart.series" [chart]="usersByPartyChart.chart"
              [xaxis]="usersByPartyChart.xaxis" [colors]="usersByPartyChart.colors"
              [plotOptions]="usersByPartyChart.plotOptions" [dataLabels]="usersByPartyChart.dataLabels"
              [tooltip]="usersByPartyChart.tooltip">
            </apx-chart>
          </div>
        </div>
      </div>

      <!-- Deuxième ligne - Graphique en ligne -->
      <div class="p-4 bg-white border border-gray-200 rounded-lg shadow">
        <h3 class="mb-3 font-medium text-gray-800">Cartes générés par
          inspection</h3>
        <div>
          <apx-chart [series]="inspectionTrendChart.series" [chart]="inspectionTrendChart.chart"
            [colors]="inspectionTrendChart.colors" [stroke]="inspectionTrendChart.stroke"
            [xaxis]="inspectionTrendChart.xaxis" [yaxis]="inspectionTrendChart.yaxis" [grid]="inspectionTrendChart.grid"
            [tooltip]="inspectionTrendChart.tooltip">
          </apx-chart>
        </div>
        <div class="mt-4 text-sm text-gray-600">
          <p>Ce graphique montre l'évolution du nombre d'inspections au cours
            des derniers mois.</p>
        </div>
      </div>
    </div>

    <!-- Deuxième colonne - Statistiques -->
    <div class="w-full mt-3 md:w-1/3">
      <!-- Miniature réduite -->
      <div *ngIf="isStatsCardCollapsed" (click)="toggleStatsCard()"
        class="p-3 transition-colors duration-200 bg-white border border-gray-200 rounded-lg shadow cursor-pointer hover:bg-gray-50">
        <div class="flex items-center justify-between">
          <h3 class="text-sm font-medium text-gray-700">
            <span class="mr-2 text-xl">📊</span> Statistiques
          </h3>
          <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </div>
      </div>

      <!-- Carte complète -->
      <div *ngIf="!isStatsCardCollapsed" class="overflow-hidden bg-white border border-gray-200 rounded-lg shadow">
        <div class="p-4">
          <div class="flex items-center justify-between mb-4">
            <h2 class="text-lg font-semibold text-gray-800">Statistiques</h2>
            <button (click)="toggleStatsCard()"
              class="flex items-center justify-center w-8 h-8 text-gray-500 transition-colors hover:text-gray-700">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>

          <!-- Carte Statistiques générales -->
          <div class="mb-6">
            <h3 class="mb-2 font-medium text-gray-700">Activité globale</h3>
            <div class="grid grid-cols-2 gap-4">
              <div class="p-3 border border-blue-100 rounded-lg bg-blue-50">
                <p class="text-sm text-blue-800">Utilisateurs totales</p>
                <p class="text-2xl font-bold text-blue-600">
                  {{ utilisateurs.length-1 }}</p>
              </div>
              <div class="p-3 border border-green-100 rounded-lg bg-green-50">
                <p class="text-sm text-green-800"> Cartes d'inspections
                  générés</p>
                <p class="text-2xl font-bold text-green-600">{{ cardCreated
                  }}</p>
              </div>
              <div class="p-3 border border-purple-100 rounded-lg bg-purple-50">
                <p class="text-sm text-purple-800">Rapport d'inspection
                  totales</p>
                <p class="text-2xl font-bold text-purple-600">{{ rapportCreated
                  }}</p>
              </div>
              <div class="p-3 border border-yellow-100 rounded-lg bg-yellow-50">
                <p class="text-sm text-yellow-800">Montant généré</p>
                <p class="text-xl font-bold text-yellow-600">{{ amountCard |
                  number:'1.1-2'
                  }} XAF</p>
              </div>
            </div>
          </div>

          <!-- Carte Détails -->
          <!-- <div class="mb-6">
            <h3 class="mb-2 font-medium text-gray-700">Détails inspections</h3>
            <div class="p-4 border border-gray-200 rounded-lg bg-gray-50">
              <div class="flex items-center mb-3">
                <div
                  class="flex items-center justify-center w-10 h-10 mr-3 bg-blue-100 border border-blue-200 rounded-full">
                  <span class="font-medium text-blue-600">IS</span>
                </div>
                <div>
                  <h4 class="font-medium text-gray-800">Inspection Sécurité</h4>
                  <p class="text-xs text-gray-500">Dernière: 15/06/2023</p>
                </div>
              </div>

              <div class="space-y-3">
                <div>
                  <p class="text-sm text-gray-600">Complétées: <span
                      class="font-medium text-blue-600">58</span></p>
                  <div class="w-full h-2 mt-1 bg-gray-200 rounded-full">
                    <div class="h-2 bg-blue-600 rounded-full"
                      style="width: 75%"></div>
                  </div>
                  <span class="ml-2 text-xs text-blue-500">75%</span>
                </div>
                <div>
                  <p class="text-sm text-gray-600">En retard: <span
                      class="font-medium text-green-600">12</span></p>
                  <div class="w-full h-2 mt-1 bg-gray-200 rounded-full">
                    <div class="h-2 bg-green-600 rounded-full"
                      style="width: 15%"></div>
                  </div>
                  <span class="ml-2 text-xs text-green-500">15%</span>
                </div>
              </div>
            </div>
          </div> -->

          <!-- Carte Actions rapides -->
          <div>
            <h3 class="mb-2 font-medium text-gray-700">Actions rapides</h3>
            <div class="space-y-2">
              <button (click)="openNewInspectionModal()"
                class="flex items-center justify-between w-full px-4 py-2 transition bg-gray-100 border border-gray-200 rounded-lg hover:bg-gray-200">
                <span>Nouveau partenaire</span>
                <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6">
                  </path>
                </svg>
              </button>

              <button (click)="openInspectionAmountModal()"
                class="flex items-center justify-between w-full px-4 py-2 transition bg-gray-100 border border-gray-200 rounded-lg hover:bg-gray-200">
                <span> montant d'inspection</span>
                <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6">
                  </path>
                </svg>
              </button>
              <button
                class="flex items-center justify-between w-full px-4 py-2 transition bg-gray-100 border border-gray-200 rounded-lg hover:bg-gray-200">
                <span>Générer rapport</span>
                <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                  </path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="grid grid-cols-1 gap-4 mt-8">
    <h2 class="text-xl font-semibold text-gray-800">Journal des Authentifications</h2>

    <!-- Filtres et contrôles -->
    <div class="p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
      <div class="grid grid-cols-1 gap-4 md:grid-cols-4">
        <!-- Recherche par utilisateur -->
        <div>
          <label class="block mb-2 text-sm font-medium text-gray-700">Rechercher utilisateur</label>
          <input type="text" placeholder="Nom d'utilisateur..." [(ngModel)]="authLogSearch"
            class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
        </div>

        <!-- Filtre par date -->
        <div>
          <label class="block mb-2 text-sm font-medium text-gray-700">Date de début</label>
          <input type="date" [(ngModel)]="authLogStartDate"
            class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
        </div>

        <div>
          <label class="block mb-2 text-sm font-medium text-gray-700">Date de fin</label>
          <input type="date" [(ngModel)]="authLogEndDate"
            class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
        </div>

        <!-- Actions -->
        <div class="flex items-end space-x-2">
          <button (click)="applyAuthLogFilters()"
            class="w-full px-4 py-2 text-white transition bg-gray-600 rounded-lg hover:bg-gray-700">
            Appliquer
          </button>
          <button (click)="resetAuthLogFilters()"
            class="w-full px-4 py-2 text-gray-700 transition bg-gray-200 rounded-lg hover:bg-gray-300">
            Réinitialiser
          </button>
        </div>
      </div>
    </div>

    <!-- Tableau des logs d'authentification -->
    <div class="p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
      <div class="flex items-center justify-between mb-4">
        <div>
          <h3 class="text-lg font-semibold text-gray-800">Historique des connexions</h3>
          <p class="text-sm text-gray-600">{{ filteredAuthLogs.length }} authentification(s) trouvée(s)</p>
        </div>
        <div class="flex items-center space-x-3">
          <button (click)="exportAuthLogs()"
            class="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 transition bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            Exporter
          </button>

        </div>
      </div>

      <div class="overflow-x-auto">
        <table class="w-full text-sm text-left text-gray-800">
          <thead class="text-xs text-gray-700 uppercase bg-gray-100">
            <tr>
              <th class="px-4 py-3 cursor-pointer" (click)="sortAuthLogs('utilisateur.nom')">
                <div class="flex items-center space-x-1">
                  <span>Utilisateur</span>
                  <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                  </svg>
                </div>
              </th>
              <th class="px-4 py-3 cursor-pointer" (click)="sortAuthLogs('date')">
                <div class="flex items-center space-x-1">
                  <span>Date & Heure</span>
                  <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                  </svg>
                </div>
              </th>
              <th class="px-4 py-3">Localisation</th>
              <th class="px-4 py-3">Adresse Ip</th>
              <th class="px-4 py-3">Status</th>
              <th class="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let log of paginatedAuthLogs" class="transition bg-white border-b hover:bg-gray-50">
              <!-- Utilisateur -->
              <td class="px-4 py-3">
                <div class="flex items-center space-x-3">
                  <div class="flex items-center justify-center w-8 h-8 bg-blue-100 rounded-full">
                    <span class="text-sm font-medium text-blue-600">
                      {{ log.utilisateur?.nom?.charAt(0) }}{{ log.utilisateur?.prenom?.charAt(0) }}
                    </span>
                  </div>
                  <div>
                    <div class="font-medium text-gray-900">
                      {{ log.utilisateur?.nom }} {{ log.utilisateur?.prenom }}
                    </div>
                    <div class="text-xs text-gray-500">{{ log.utilisateur?.userName }}</div>
                  </div>
                </div>
              </td>

              <!-- Date & Heure -->
              <td class="px-4 py-3">
                <div class="text-sm font-medium text-gray-900">
                  {{ log.date | date:'dd/MM/yyyy' }}
                </div>
                <div class="text-xs text-gray-500">
                  {{ log.date | date:'HH:mm:ss' }}
                </div>
              </td>

              <!-- Localisation -->
              <td class="px-4 py-3">
                <div class="flex items-center space-x-2">
                  <svg class="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <div>
                    <div class="text-sm font-medium text-gray-900" *ngIf="log.localisation; else unknownLocation">
                      {{ log.localisation }}
                    </div>
                    <ng-template #unknownLocation>
                      <div class="text-sm text-gray-500">Localisation inconnue</div>
                    </ng-template>
                    <div class="text-xs text-gray-500" *ngIf="getLocationDetails(log.localisation) as location">
                      {{ location.city }}, {{ location.country }}
                    </div>
                  </div>
                </div>
              </td>

              <!-- IP & Device -->
              <td class="px-4 py-3">
                <div class="text-xs">
                  <div class="font-mono text-gray-900">{{ getIPFromLocation(log.localisation) }}</div>
                  <div class="text-gray-500">{{ getDeviceInfo(log) }}</div>
                </div>
              </td>

              <!-- Statut -->
              <td class="px-4 py-3">
                <span
                  class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                  Réussie
                </span>
              </td>

              <!-- Actions -->
              <td class="px-4 py-3">
                <button (click)="viewAuthLogDetails(log)"
                  class="flex items-center gap-1 px-3 py-1 text-xs text-blue-600 transition rounded-lg bg-blue-50 hover:bg-blue-100">
                  <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                  Détails
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Message vide -->
        <div *ngIf="filteredAuthLogs.length === 0" class="p-8 text-center text-gray-500">
          <svg class="w-12 h-12 mx-auto text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <p class="mt-2 text-sm">Aucune authentification trouvée</p>
          <p class="text-xs">Ajustez vos filtres pour voir plus de résultats</p>
        </div>
      </div>

      <!-- Pagination -->
      <div class="flex items-center justify-between pt-4 mt-4 border-t border-gray-200">
        <span class="text-sm text-gray-700">
          Affichage de <span class="font-semibold">{{ authLogStartIndex + 1 }}-{{ authLogEndIndex }}</span>
          sur <span class="font-semibold">{{ filteredAuthLogs.length }}</span> entrées
        </span>
        <div class="flex space-x-2">
          <button (click)="previousAuthLogPage()" [disabled]="authLogCurrentPage === 1"
            class="flex items-center justify-center w-8 h-8 text-sm font-medium text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
            ‹
          </button>
          <span *ngFor="let page of authLogVisiblePages" (click)="goToAuthLogPage(page)" [ngClass]="{
                'bg-blue-50 text-blue-600 border-blue-300': authLogCurrentPage === page,
                'bg-white text-gray-800 border-gray-300': authLogCurrentPage !== page
              }" class="flex items-center justify-center w-8 h-8 text-sm font-medium border rounded-lg cursor-pointer">
            {{ page }}
          </span>
          <button (click)="nextAuthLogPage()" [disabled]="authLogCurrentPage === authLogTotalPages"
            class="flex items-center justify-center w-8 h-8 text-sm font-medium text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
            ›
          </button>
        </div>
      </div>
    </div>

  </div>
  <div class="grid grid-cols-1 gap-4 mt-8">
    <h2 class="text-xl font-semibold text-gray-800">Journal des Historiques de Scan</h2>

    <!-- Filtres et contrôles -->
    <div class="p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
      <div class="grid grid-cols-1 gap-4 md:grid-cols-4">
        <!-- Recherche par utilisateur -->
        <div>
          <label class="block mb-2 text-sm font-medium text-gray-700">Rechercher utilisateur</label>
          <input type="text" placeholder="Nom d'utilisateur..." [(ngModel)]="authLogSearch"
            class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
        </div>

        <!-- Filtre par date -->
        <div>
          <label class="block mb-2 text-sm font-medium text-gray-700">Date de début</label>
          <input type="date" [(ngModel)]="authLogStartDate"
            class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
        </div>

        <div>
          <label class="block mb-2 text-sm font-medium text-gray-700">Date de fin</label>
          <input type="date" [(ngModel)]="authLogEndDate"
            class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
        </div>

        <!-- Actions -->
        <div class="flex items-end space-x-2">
          <button (click)="applyAuthLogFilters()"
            class="w-full px-4 py-2 text-white transition bg-gray-600 rounded-lg hover:bg-gray-700">
            Appliquer
          </button>
          <button (click)="resetAuthLogFilters()"
            class="w-full px-4 py-2 text-gray-700 transition bg-gray-200 rounded-lg hover:bg-gray-300">
            Réinitialiser
          </button>
        </div>
      </div>
    </div>

    <!-- Tableau des logs d'authentification -->
    <div class="p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
      <div class="flex items-center justify-between mb-4">
        <div>
          <h3 class="text-lg font-semibold text-gray-800">Historique des Scans Badge</h3>
          <p class="text-sm text-gray-600">{{ historiquesScans.length }} Historique de scan(s) trouvé(s)</p>
        </div>
        <div class="flex items-center space-x-3">
          <button (click)="exportAuthLogs()"
            class="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 transition bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            Exporter
          </button>

        </div>
      </div>

      <div class="overflow-x-auto">
        <table class="w-full text-sm text-left text-gray-800">
          <thead class="text-xs text-gray-700 uppercase bg-gray-100">
            <tr>
              <th class="px-4 py-3 cursor-pointer" (click)="sortAuthLogs('utilisateur.nom')">
                <div class="flex items-center space-x-1">
                  <span>Utilisateur</span>
                  <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                  </svg>
                </div>
              </th>
              <th class="px-4 py-3 cursor-pointer" (click)="sortAuthLogs('date')">
                <div class="flex items-center space-x-1">
                  <span>Date & Heure</span>
                  <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                  </svg>
                </div>
              </th>
              <th class="px-4 py-3">Statut</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let scan of historiquesScans" class="transition bg-white border-b hover:bg-gray-50">
              <!-- Utilisateur -->
              <td class="px-4 py-3">
                <div class="flex items-center space-x-3">
                  <div class="flex items-center justify-center w-8 h-8 bg-blue-100 rounded-full">
                    <span class="text-sm font-medium text-blue-600">
                      {{ scan.utilisateur?.nom?.charAt(0) }}{{ scan.utilisateur?.prenom?.charAt(0) }}
                    </span>
                  </div>
                  <div>
                    <div class="font-medium text-gray-900">
                      {{ scan.utilisateur?.nom }} {{ scan.utilisateur?.prenom }}
                    </div>
                    <div class="text-xs text-gray-500">{{ scan.utilisateur?.userName }}</div>
                  </div>
                </div>
              </td>

              <!-- Date & Heure -->
              <td class="px-4 py-3">
                <div class="text-sm font-medium text-gray-900">
                  {{ scan.date | date:'dd/MM/yyyy' }}
                </div>
                <div class="text-xs text-gray-500">
                  {{ scan.date | date:'HH:mm:ss' }}
                </div>
              </td>




              <!-- Statut -->
              <td class="px-4 py-3">
                <span
                  class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                  Réussie
                </span>
              </td>


            </tr>
          </tbody>
        </table>

        <!-- Message vide -->
        <div *ngIf="filteredAuthLogs.length === 0" class="p-8 text-center text-gray-500">
          <svg class="w-12 h-12 mx-auto text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <p class="mt-2 text-sm">Aucun Historique de Scan trouvé</p>
          <p class="text-xs">Ajustez vos filtres pour voir plus de résultats</p>
        </div>
      </div>

      <!-- Pagination -->
      <div class="flex items-center justify-between pt-4 mt-4 border-t border-gray-200">
        <span class="text-sm text-gray-700">
          Affichage de <span class="font-semibold">{{ authLogStartIndex + 1 }}-{{ historiquesScans.length }}</span>
          sur <span class="font-semibold">{{ historiquesScans.length }}</span> entrées
        </span>
        <div class="flex space-x-2">
          <button (click)="previousAuthLogPage()" [disabled]="authLogCurrentPage === 1"
            class="flex items-center justify-center w-8 h-8 text-sm font-medium text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
            ‹
          </button>
          <span *ngFor="let page of authLogVisiblePages" (click)="goToAuthLogPage(page)" [ngClass]="{
                'bg-blue-50 text-blue-600 border-blue-300': authLogCurrentPage === page,
                'bg-white text-gray-800 border-gray-300': authLogCurrentPage !== page
              }" class="flex items-center justify-center w-8 h-8 text-sm font-medium border rounded-lg cursor-pointer">
            {{ page }}
          </span>
          <button (click)="nextAuthLogPage()" [disabled]="authLogCurrentPage === authLogTotalPages"
            class="flex items-center justify-center w-8 h-8 text-sm font-medium text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
            ›
          </button>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- Modal de confirmation -->
<div *ngIf="showConfirmationModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="p-6 bg-white border border-gray-200 rounded-lg shadow-lg w-96">
    <h3 class="mb-4 text-xl font-semibold text-gray-800">Confirmer l'action</h3>
    <p class="text-gray-600">
      Êtes-vous sûr de vouloir {{ origin == 'Desactivation'
      ? (selectedPartner?.status ? 'désactiver' : 'activer')
      : 'Supprimer' }}

      le partenaire {{ selectedPartner?.nom }} ?
    </p>
    <div class="flex justify-end mt-6 space-x-3">
      <button (click)="showConfirmationModal = false"
        class="px-4 py-2 text-gray-700 bg-gray-200 border border-gray-300 rounded-lg hover:bg-gray-300">
        Annuler
      </button>
      <button (click)="handleClick()"
        class="px-4 py-2 text-white bg-red-600 border border-red-700 rounded-lg hover:bg-red-700">
        Confirmer
      </button>
    </div>
  </div>
</div>

<!-- Modal de détails d'authentification -->
<div *ngIf="showAuthLogDetailsModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="w-11/12 max-w-2xl p-6 bg-white border border-gray-200 rounded-lg shadow-lg">
    <div class="flex items-center justify-between mb-6">
      <h3 class="text-xl font-semibold text-gray-800">Détails de l'authentification</h3>
      <button (click)="closeAuthLogDetailsModal()" class="text-gray-500 hover:text-gray-700">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="space-y-6" *ngIf="selectedAuthLog">
      <!-- Informations utilisateur -->
      <div class="p-4 rounded-lg bg-gray-50">
        <h4 class="mb-3 font-medium text-gray-800">Informations utilisateur</h4>
        <div class="grid grid-cols-2 gap-4 text-sm">
          <div>
            <span class="text-gray-600">Nom complet:</span>
            <p class="font-medium">{{ selectedAuthLog.utilisateur?.nom }} {{ selectedAuthLog.utilisateur?.prenom }}</p>
          </div>
          <div>
            <span class="text-gray-600">Nom d'utilisateur:</span>
            <p class="font-medium">{{ selectedAuthLog.utilisateur?.userName }}</p>
          </div>
          <div>
            <span class="text-gray-600">Email:</span>
            <p class="font-medium">{{ selectedAuthLog.utilisateur?.email }}</p>
          </div>
          <div>
            <span class="text-gray-600">Rôle:</span>
            <p class="font-medium">{{ selectedAuthLog.utilisateur?.role }}</p>
          </div>
        </div>
      </div>

      <!-- Informations de connexion -->
      <div class="p-4 rounded-lg bg-gray-50">
        <h4 class="mb-3 font-medium text-gray-800">Informations de connexion</h4>
        <div class="grid grid-cols-2 gap-4 text-sm">
          <div>
            <span class="text-gray-600">Date et heure:</span>
            <p class="font-medium">{{ selectedAuthLog.date | date:'dd/MM/yyyy à HH:mm:ss' }}</p>
          </div>
          <div>
            <span class="text-gray-600">Statut:</span>
            <span
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
              Réussie
            </span>
          </div>
          <div class="col-span-2">
            <span class="text-gray-600">Localisation:</span>
            <p class="font-medium">{{ selectedAuthLog.localisation || 'Non disponible' }}</p>
          </div>
        </div>
      </div>

      <!-- Carte de localisation (optionnelle) -->
      <div class="p-4 rounded-lg bg-gray-50" *ngIf="selectedAuthLog.localisation">
        <h4 class="mb-3 font-medium text-gray-800">Localisation approximative</h4>
        <div class="flex items-center space-x-2 text-sm text-gray-600">
          <svg class="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <span>Basé sur l'adresse IP: {{ getIPFromLocation(selectedAuthLog.localisation) }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal de inspectionMontant confirmation -->
<div *ngIf="showConfirmationInspectionMontantModal"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="p-6 bg-white border border-gray-200 rounded-lg shadow-lg w-96">
    <h3 class="mb-4 text-xl font-semibold text-gray-800">Confirmer l'action</h3>
    <p class="text-gray-600">
      Êtes-vous sûr de vouloir supprimer ce montant pour en fournir un autre

    </p>
    <div class="flex justify-end mt-6 space-x-3">
      <button (click)="showConfirmationInspectionMontantModal = false"
        class="px-4 py-2 text-gray-700 bg-gray-200 border border-gray-300 rounded-lg hover:bg-gray-300">
        Annuler
      </button>
      <button (click)="deleteInspectionMontant(inspectionMontant.id)"
        class="px-4 py-2 text-white bg-red-600 border border-red-700 rounded-lg hover:bg-red-700">
        Confirmer
      </button>
    </div>
  </div>
</div>
<!-- Modal de détails -->
<div *ngIf="showDetailsModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="w-11/12 max-w-2xl p-6 bg-white border border-gray-200 rounded-lg shadow-lg">
    <div class="flex justify-between mb-4">
      <h3 class="text-xl font-semibold text-gray-800">Détails du partenaire</h3>
      <button (click)="showDetailsModal = false" class="text-gray-500 hover:text-gray-700">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <div class="space-y-4">
      <div>
        <h4 class="font-medium text-gray-800">{{ selectedPartner?.nom }}</h4>
        <p class="text-sm text-gray-600">
          Créé le: {{ selectedPartner?.createdDate | date:'mediumDate' }}
        </p>
      </div>

      <div class="flex items-center">
        <span class="mr-2 text-gray-700">Statut:</span>
        <span class="inline-flex items-center px-3 py-1 text-sm font-medium rounded-full"
          [ngClass]="selectedPartner?.status ? 'text-green-800 bg-green-100' : 'text-red-800 bg-red-100'">
          {{ selectedPartner?.status ? "Active" : "Désactivé" }}
        </span>
      </div>

      <div class="flex justify-end pt-4 mt-4 border-t border-gray-200">
        <button (click)="openEditModal(selectedPartner)"
          class="flex items-center px-4 py-2 text-white bg-green-500 border rounded-lg">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-1" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
          </svg>
          Modifier
        </button>&nbsp;
        <button (click)="openConfirmationModal('Desactivation')"
          class="flex items-center px-4 py-2 text-white border rounded-lg"
          [ngClass]="selectedPartner?.status ? 'bg-yellow-600 border-yellow-700 hover:bg-yellow-700' : 'bg-green-600 border-green-700 hover:bg-green-700'">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-1" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          {{ selectedPartner?.status ? 'Désactiver' : 'Activer' }}
        </button>&nbsp;
        <button (click)="openConfirmationModal('Suppression')"
          class="flex items-center px-4 py-2 text-white bg-red-500 border rounded-lg">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-1" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
          Supprimer
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal InspectionMontant détails -->
<div *ngIf="showInspectionMontantDetailsModal"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="w-11/12 max-w-2xl p-6 bg-white border border-gray-200 rounded-lg shadow-lg">
    <div class="flex justify-between mb-4">
      <h3 class="text-xl font-semibold text-gray-800">Détails de montant des
        rapports d'inspections</h3>
      <button (click)="showInspectionMontantDetailsModal = false" class="text-gray-500 hover:text-gray-700">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <div class="space-y-4">
      <div>
        <h4 class="font-medium text-gray-800">{{ inspectionMontant.montant |
          number:'1.1-2'
          }} XAF</h4>
        <p class="text-sm text-gray-600">
          Créé le: {{ inspectionMontant?.createdDate | date:'mediumDate' }}
        </p>
      </div>

      <div class="flex justify-end pt-4 mt-4 border-t border-gray-200">
        <!-- <button (click)="openEditModal(selectedPartner)"
          class="flex items-center px-4 py-2 text-white bg-green-500 border rounded-lg">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-1"
            fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              stroke-width="2"
              d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
          </svg>
          Modifier
        </button>&nbsp; -->
        <!-- <button (click)="openConfirmationModal('Desactivation')"
          class="flex items-center px-4 py-2 text-white border rounded-lg"
          [ngClass]="selectedPartner?.status ? 'bg-yellow-600 border-yellow-700 hover:bg-yellow-700' : 'bg-green-600 border-green-700 hover:bg-green-700'">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-1"
            fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          {{ selectedPartner?.status ? 'Désactiver' : 'Activer' }}
        </button>&nbsp; -->
        <button (click)="openConfirmationModalForInspectionMontant(inspectionMontant.id)"
          class="flex items-center px-4 py-2 text-white bg-red-500 border rounded-lg">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-1" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
          Supprimer
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Modal Nouvelle Inspection -->
<div *ngIf="showNewInspectionModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="w-11/12 max-w-2xl p-6 bg-white border border-gray-200 rounded-lg shadow-lg">
    <h2 class="font-medium text-gray-800">Créer/Modifier une inspection</h2>
    <form (ngSubmit)="submitInspection()" class="space-y-4">
      <!-- Champ Nom -->
      <div>
        <label class="block mb-2 text-sm font-medium text-gray-700">Nom</label>
        <input type="text" [(ngModel)]="newInspection.nom" name="nom"
          class="w-full p-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
          [class.border-red-500]="!newInspection.nom" [class.bg-red-50]="!newInspection.nom">
        <div *ngIf="!newInspection.nom" class="mt-1 text-sm text-red-600">
          Le nom est obligatoire
        </div>
      </div>

      <!-- Champ Code -->
      <div>
        <label class="block mb-2 text-sm font-medium text-gray-700">Code</label>
        <input type="text" [(ngModel)]="newInspection.code" name="code"
          class="w-full p-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
          [class.border-red-500]="!newInspection.code" [class.bg-red-50]="!newInspection.code">
        <div *ngIf="!newInspection.code" class="mt-1 text-sm text-red-600">
          Le code est obligatoire
        </div>
      </div>

      <!-- Champ Type -->
      <div>
        <label class="block mb-2 text-sm font-medium text-gray-700">Gestion des partenaires</label>
        <select [(ngModel)]="newInspection.type" name="type"
          class="w-full p-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500">
          <option value="UTILISATEUR">Utilisateur</option>
          <option value="INSPECTEUR">Inspecteur</option>
          <option value="OPERATEUR">Operateur</option>
          <option value="ENTREPRISE">Entreprise</option>
          <option value="CONTROLLEUR">Controlleur</option>
        </select>
      </div>

      <!-- Champ Logo -->
      <div>
        <label class="block mb-2 text-sm font-medium text-gray-700">Logo</label>
        <div class="flex items-center space-x-4">
          <div *ngIf="filePreview" class="w-16 h-16 overflow-hidden border border-gray-300 rounded-lg">
            <img [src]="filePreview" class="object-cover w-full h-full" alt="Preview logo">
          </div>
          <label class="flex-1">
            <div
              class="p-2 text-center border border-gray-300 border-dashed rounded-lg cursor-pointer hover:bg-gray-50">
              <span class="text-sm text-gray-600">
                {{ selectedFile ? selectedFile.name : 'Choisir un fichier' }}
              </span>
              <input type="file" (change)="onFileSelected($event)" accept="image/*" class="hidden" name="logo">
            </div>
          </label>
        </div>
      </div>

      <!-- Boutons de soumission -->
      <div class="flex justify-end pt-4 mt-4 space-x-3 border-t border-gray-200">
        <button type="button" (click)="closeNewInspectionModal()"
          class="px-4 py-2 text-gray-700 bg-gray-200 border border-gray-300 rounded-lg hover:bg-gray-300">
          Annuler
        </button>
        <button type="submit"
          class="px-4 py-2 text-white bg-blue-600 border border-blue-700 rounded-lg hover:bg-blue-700"
          [disabled]="!isFormValid()">
          Créer
        </button>
      </div>
    </form>
  </div>
</div>

<div *ngIf="showInspectionAmountModal"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="w-11/12 max-w-2xl p-6 bg-white border border-gray-200 rounded-lg shadow-lg">
    <!-- <h2 class="font-medium text-gray-800">Définir montant des inspections</h2> -->
    <form class="space-y-4">
      <!-- Champ Nom -->
      <div>
        <label class="block mb-2 text-sm font-medium text-gray-700">Montant *</label>
        <input type="number" [(ngModel)]="montant" name="montant"
          class="w-full p-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
          [class.border-red-500]="!montant" [class.bg-red-50]="!montant">
        <div *ngIf="!montant" class="mt-1 text-sm text-red-600">
          Veuillez renseigner le montant
        </div>
      </div>

      <!-- Boutons de soumission -->
      <div class="flex justify-end pt-4 mt-4 space-x-3 border-t border-gray-200">
        <button type="button" (click)="closeInspectionAmountModal()"
          class="px-4 py-2 text-gray-700 bg-gray-200 border border-gray-300 rounded-lg hover:bg-gray-300">
          Annuler
        </button>
        <button type="submit"
          class="px-4 py-2 text-white bg-blue-600 border border-blue-700 rounded-lg hover:bg-blue-700"
          (click)="submitInspectionMontant()">
          Créer
        </button>
      </div>
    </form>
  </div>
</div>